module.exports = __webpack_public_path__ + "img/logo-menu-branco.ed708f2f.png";